null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.33/scalalib/overrides-2.12/scala/Console.scala